import Vue from "vue";
import VeeValidate from "vee-validate";
import widgets from "./js/widgets";
import icons from "./js/icons";

Vue.use(VeeValidate);

const packages = Object.assign(widgets, icons);

Object.assign(widgets, icons).install = Vue => {
  for (const componentName in packages) {
    const component = packages[componentName];

    if (component && componentName !== "install") {
      Vue.component(component.name, component);
    }
  }
};

export default packages;



//////////////////
// WEBPACK FOOTER
// ../panel-theme/src/main.js
// module id = null
// module chunks = 